var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('vs-switch',{attrs:{"color":"dark","icon-pack":"feather","vs-icon":"icon-chevron-down"},model:{value:(_vm.openTasks),callback:function ($$v) {_vm.openTasks=$$v},expression:"openTasks"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }